import type { FaireProductEntity } from "../../entity_types/product";

export const p_davxdawu2j: FaireProductEntity = {
  token: "p_davxdawu2j",
  type: "product",
  name: "Mexican Citrus Juicer - Large",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/b80a2a605612e47eaa2155ce214b9bdc2d832b4c3a3f85d929b151fbf8f9adb0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b36c1d2469115d347c592e5c0db020ed85af4256e74a0d1d107aa7698c917a75.jpeg",
    "https://cdn.faire.com/fastly/7cfc2a42cc2d62a72b957dc03cdaccbecbb3b3fef8463f66c88dd23541a08343.jpeg",
    "https://cdn.faire.com/fastly/6c226ebed270e55252bcabd0d7d97bb5d187f2dfb9e01ab1ba822ab2e1c02a52.jpeg",
    "https://cdn.faire.com/fastly/deb31c1697c291475b9a2cdbeb100d8740c83ce2e01428dc56d37c2a2b29d8f3.jpeg",
    "https://cdn.faire.com/fastly/2723216ac1bd0f1f2f654d126cd945644a39b828a3696d21e4a2d755db7966f2.jpeg",
    "https://cdn.faire.com/fastly/2fbd0b75d3945c774b4a773aefab201497cdfbcc7a791f175d5be86f3828db7f.jpeg",
    "https://cdn.faire.com/fastly/8190aa6d041603259639a1ca1ed35c315d95bd94606846bf4e341c6aed50ba19.jpeg",
    "https://cdn.faire.com/fastly/6203d8d777170914a3e8e602adbdaa692303f1f10af4c0d365f3f8cd55345067.jpeg",
  ],
  priceDollars: 90,
  description:
    "Transform holiday gatherings with the Verve Culture Artisan Citrus Juicer, a perfect gift for any occasion. Crafted from durable, recycled, cast aluminum, this authentic tool brings the charm of traditional markets to your kitchen. Delight in making delicious, healthy juices or crafting unique cocktails with friends and family. Size ideal for med-large citrus fruits.\n\nThe juicer comes beautifully packaged in a gift box, making it an ideal present for holiday gift exchanges, Christmas, weddings, housewarmings, Mother’s Day, Father’s Day, and other special celebrations. Included is a booklet with recipes, fun facts, and easy cleaning instructions to enhance the gift experience.\n\nThis Juicer is not just a tool, but a centerpiece for memories with loved ones. Perfect for gifting, this juicer combines functionality with a touch of heritage, making it a thoughtful addition to any wish list.\n\nHandle up/juicer open: 18''L x 8''W x 24''H\nHandle down/juicer closed: 19''L x 8''W x 17''H",
  tags: [],
  msrpDollars: 180,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:52.910Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
